<template>
	<div>
		<HeadIndex v-on:HeadIndexSearch="HeadIndexSearch($event)"></HeadIndex>
		<el-row>
			<!-- <el-col :span="22" :offset="1">
				<div class="Page_heading ">
					<div class="search_input_top">
						<el-form :model="form" label-width="auto">
							<el-row>
								<el-col :span="24" class="name">
									<el-form-item label="品牌：">
										<el-button key="warning" type="" link>
											全部
										</el-button>
										<el-button key="warning" type="" link>
											ABB
										</el-button>
										<el-button key="warning" type="" link>
											泰永
										</el-button>
										<el-button key="warning" type="" link>
											北京明日
										</el-button>
										<el-button key="warning" type="" link>
											施耐德万高
										</el-button>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="6">
									<el-form-item label="产品状态：">
										<el-select v-model="form.region" placeholder="选择" size="default">
											<el-option label="全部" value="1" />
											<el-option label="A 滞纳、在保、包附完好" value="2" />
											<el-option label="B 滞纳、在保、包附破损" value="3" />
											<el-option label="C 滞纳、过保、包附完好" value="4" />
											<el-option label="D 滞纳、过保、包附破损" value="5" />
										</el-select>
									</el-form-item>
								</el-col>
							</el-row>
							<el-row>
								<el-col :span="24" class="info">
									<el-form-item label="产品类型：">
										<el-button size="small">对应产品资源</el-button>
										<el-button size="small">被替代产品资源</el-button>
									</el-form-item>
								</el-col>
							</el-row>
						</el-form>
					</div>
				</div>
			</el-col> -->
			<el-col :span="22" :offset="1">
				<div class="Page_heading" style="border-radius: 10px;">
					<!-- <el-row class="search_input">
						<el-col :span="4" class="acquiesce">
							<el-button size="small">默认</el-button>
							<el-button size="small">发布时间</el-button>
							<el-button size="small">价格</el-button>
						</el-col>
						<el-col :span="7" class="district">
							<el-input v-model="input3" size="small" placeholder="" class="input-with-select">
								<template #prepend>
									<el-button size="small">地区</el-button>
								</template>
								<template #append>
									<el-button size="small">取消</el-button>
									<el-button :icon="Search" />
								</template>
							</el-input>
						</el-col>
						<el-col :span="7" class="district">
							<el-input v-model="input3" size="small" placeholder="" class="input-with-select">
								<template #append>
									<el-button size="small">搜索</el-button>
								</template>
							</el-input>
						</el-col>
					</el-row> -->
					<el-row class="">
						<el-col :span="24" class="">
							<div ref="height_top">
								<el-table :row-style="addStyle" :cell-style="cellStyle" @row-click="rowClick" :row-class-name="tableRowClassName" :data="tableData" @row-dblclick="rowDblclick" :height="tableHeight" :header-cell-style="{'background-color': '#e5e5e5'}" size="small" v-loading="loading" style="width: 100%;border-radius: 10px;">
									<el-table-column prop="img" label="实图"  width="50" header-align="center" show-overflow-tooltip>
										<template #default="scope">
											<div v-if="scope.row.img.length <= 0">
												<div>
													<el-image style="" :src="require('@/assets/img/error_img.png')" loading="lazy"/>
												</div>
											</div>
											<div v-else>
												<div @click="preview(scope.row,scope.row.img)">
													<el-image style="" :src="scope.row.img[0]" loading="lazy"/>
												</div>
												<!-- <el-icon style=" color: #29afa5; "  size="20">
												<PictureFilled size="20" />
											</el-icon> -->
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="" label="" width="20" show-overflow-tooltip >
										
									</el-table-column>
									<el-table-column prop="stock_type_txt" label="货物状态" header-align="center"  width="170" show-overflow-tooltip>
										<template #default="scope">
											<div class="stock_type_txt_button">
												<span v-for="item in scope.row.stock_type_txt_list">
													<el-button class="A" size="small" text bg v-if="item=='二手' || item=='过保' || item=='包附破损'" style="">{{item}}</el-button>
													
													<el-button class="C" size="small" text bg v-else color="#ff8a5c">{{item}}</el-button>
												</span>
											</div>
											<!-- <el-button-group class="ml-4">
										    <el-button size="small"/>
										    <el-button size="small" />
										    <el-button size="small" />
										  </el-button-group> -->
										</template>
									</el-table-column>
									<el-table-column prop="" label="" width="20" show-overflow-tooltip />
									<el-table-column prop="brand_name" label="品牌" width="150" show-overflow-tooltip >
										<template #default="scope">
											<span v-if="scope.row.brand_name">
												{{scope.row.brand_name}}
											</span>
											<span v-else>
												-
											</span>
										</template>
									</el-table-column>
									<el-table-column prop="" label="" width="20" show-overflow-tooltip />
									<el-table-column prop="name" label="品名" width="150" show-overflow-tooltip >
										<template #default="scope">
											<span v-if="scope.row.name">
												{{scope.row.name}}
											</span>
											<span v-else>
												-
											</span>
										</template>
									</el-table-column>
									<el-table-column prop="" label="" width="20" show-overflow-tooltip />
									<el-table-column prop="model" label="型号" min-width="230" show-overflow-tooltip >
									<template #default="scope">
											<span v-if="scope.row.model">
												{{scope.row.model}}
											</span>
											<span v-else>
												-
											</span>
										</template>
									</el-table-column>
									<el-table-column prop="" label="" width="20" show-overflow-tooltip />
									<el-table-column prop="order_no" label="订货号" width="200" show-overflow-tooltip >
									<template #default="scope">
											<span v-if="scope.row.order_no">
												{{scope.row.order_no}}
											</span>
											<span v-else>
												-
											</span>
										</template>
									</el-table-column>
									<el-table-column prop="" label="" width="20" show-overflow-tooltip />
									<el-table-column prop="tsw_price" label="单价" width="120" show-overflow-tooltip>
										<template #default="scope">
											<el-tooltip placement="top">
												<template #content>
													<p>此信息由用户提供</p>
													<p>列表价格：{{scope.row.price}}</p>
													<p>折扣：{{scope.row.tsw_discount}}</p>
												</template>
												{{scope.row.tsw_price}}
											</el-tooltip>
										</template>
									</el-table-column>
									<el-table-column prop="" label="" width="20" show-overflow-tooltip />
									<el-table-column prop="sur_num" label="数量" width="60" show-overflow-tooltip />
									<!-- <el-table-column prop="type_name" label="用户类型" width="130" show-overflow-tooltip /> -->
									<el-table-column prop="" label="聊天" width="80" >
										<template #default="scope">
											<div class="caozuo">
												<el-icon size="18" @click="chat_click(scope.row.id)" style="color:var(--el-color-primary)">
													<ChatDotSquare />
												</el-icon>
												<!-- <el-icon size="18">
													<ShoppingCart />
												</el-icon> -->
												<!-- <el-icon size="18">
													<Edit />
												</el-icon> -->
												<!-- <el-icon size="18" style="color:#ff8a5c">
													<WarnTriangleFilled @click="report(scope.row.id)"/>
												</el-icon> -->
											</div>
											<!-- <el-icon style=" color: red "  size="20"  class="report_ico" @click="ShoppingCart(scope.row.id)">
												<ShoppingCart size="20" />
											</el-icon> -->
										</template>
									</el-table-column>
									
									<el-table-column prop="" label="" width="20" show-overflow-tooltip />
									<el-table-column prop="" label="用户类型" width="100" show-overflow-tooltip >
										<template #default="scope">
											个人用户
										</template>
									</el-table-column>
									
									<!-- <el-table-column type="selection" width="55" show-overflow-tooltip /> -->
									<!-- <el-table-column prop="img" label="实图" width="55" show-overflow-tooltip>
									<template #default="scope">
										<div v-if="scope.row.img.length <= 0">
											<el-icon  size="20" >
												<PictureFilled/>
											</el-icon>
										</div>
										<div v-else>
											<el-icon style=" color: #29afa5; "  size="20"  @click="preview(scope.row,scope.row.img)">
												<PictureFilled size="20" />
											</el-icon>
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="img" label="举报" width="55" show-overflow-tooltip>
									<template #default="scope">
										<el-icon style=" color: red "  size="20"  class="report_ico" @click="report(scope.row.id)">
											<WarnTriangleFilled/>
										</el-icon>
									</template>
								</el-table-column>
								<el-table-column prop="stock_type_txt" label="货物状态" width="180" show-overflow-tooltip />
								<el-table-column prop="brand_name" label="品牌" width="160" show-overflow-tooltip />
								<el-table-column prop="name" label="品名" width="200" show-overflow-tooltip />
								<el-table-column prop="model" label="型号" min-width="200" width="" show-overflow-tooltip />
								<el-table-column prop="order_no" label="订货号" width="200" show-overflow-tooltip />
								<el-table-column prop="address" label="列表价格" show-overflow-tooltip />
								<el-table-column prop="discount_calculate" label="折扣" show-overflow-tooltip />
								<el-table-column prop="real_price" label="单价" width="120"  show-overflow-tooltip>
									<template #default="scope">
										<el-tooltip placement="top">
											<template #content> 
												<p>此信息由用户提供</p>
												<p>列表价格：{{scope.row.price}}</p>
												<p>折扣：{{scope.row.discount_calculate}}</p>
											</template>
											{{scope.row.real_price}}
										</el-tooltip>
									</template>
								</el-table-column>
								<el-table-column prop="sur_num" label="数量" width="60" show-overflow-tooltip />
								<el-table-column prop="address" label="通讯" width="60"  show-overflow-tooltip >
									<template #default="scope">
										<el-icon size="20" @click="chat_click(scope.row.id)"><ChatDotRound /></el-icon>
									</template>
								</el-table-column>
								<el-table-column prop="type_name" label="用户类型" width="100" show-overflow-tooltip />
								<el-table-column prop="" label="购物车" width="60" show-overflow-tooltip>
									<template #default="scope">
										<el-icon style=" color: red "  size="20"  class="report_ico" @click="ShoppingCart(scope.row.id)">
												<ShoppingCart size="20" />
											</el-icon>
								
									</template>
								</el-table-column> -->
									<!-- <el-table-column prop="address" label="上架时间" show-overflow-tooltip /> -->
								</el-table>
							</div>
						</el-col>
						<el-col :span="24" ref='pagination' style="display: flex; justify-content: flex-end;">
							<el-pagination :pager-count="5" size="small" class="pagination" :current-page="page" background :page-size="parseInt(page_size)" prev-text="上一页" next-text="下一页" layout="prev,pager, next" @current-change="handleCurrentChange" :total="total">
							</el-pagination>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<el-row class="logo_m">
			<el-col :span="24">
				<div>
					CopyRight © 脱手网 2018 苏ICP备18008659号
				</div>
			</el-col>
		</el-row>
		<examineImg ref="examineImg"></examineImg>
		<chat ref="chat" v-if="chat_info" v-on:closeChat="closeChat($event)"></chat>
	</div>
</template>
<script>
import '../../assets/search/index.css' //优化表格样式
import { ElMessage, ElMessageBox } from 'element-plus'
import HeadIndex from '../public/HeadIndex';
import examineImg from '../public/img';
import chat from '../public/chat';
export default {
	name: 'search',
	components: {
		HeadIndex,
		examineImg,
		chat
	},
	data() {

		return {
			chat_info: false,

			index: [],
			srcList: [],
			tableHeight: 500,
			loading: false,
			total: 0,
			page: 1,
			page_size: 20,
			form: {},
			input3: '',
			select: '',
			filter: '',
			stock_type: '',
			img_info: '',
			tableData: [],
			user_id: '',
		}
	},
	props: [],

	updated() {

	},

	watch: {
		filter(val, newval) {}
	},
	mounted() {
		this.$nextTick(() => {
			const element = this.$refs.pagination.$el;
			const rect = element.getBoundingClientRect();
			//console.log(rect)

		})
	},

	activated() {

	},
	created() {
		this.user_id = localStorage.getItem('user_id');
		this.filter = this.$route.query.filter
		this.stock_type = this.$route.query.stock_type
		this.img_info = this.$route.query.img_info
		this.search();
		this.tableHeight_fun();
	},

	methods: {
		rowClick(row, column, e) {
			this.index = [parseInt(row.index)] //选中行this.tabClickcolumn = 1
		},
		tableRowClassName({
			row,
			rowIndex
		}) {
			row.index = rowIndex
			return ''
		},
		addStyle({ row, rowIndex }) {
			if (this.index.indexOf(rowIndex) > -1) {
                return { 'background-color': '#F2F6FC' }
            }
		},
		cellStyle({ columnIndex }) {
			if (columnIndex===0) {
                return { 'background-color': '#fff  !important' }
            }
		},
		closeChat() {
			this.chat_info = false;
		},
		async chat_click(id) {
			await this.$axios.post('/api/yunsys.storage/addchat', { id }).then(async (res) => {
					var res = res.data;
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					};
					this.chat_info = false;
					this.$nextTick(() => {
						this.chat_info = true;
						this.$nextTick(() => {
							this.$refs['chat'].dialogTableVisible = true;
							this.$refs['chat'].pitch_id = res.data.data;
							this.$refs['chat'].admin_pitch_id = res.data.data; //维护一个不变的数据 这个需要告诉后台是从哪里点进来的
							this.$nextTick(() => {
								this.$refs['chat'].search()
							})
						})
					})

				})
				.catch(err => {
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		},
		tableHeight_fun() {
			this.$nextTick(() => {
				this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100
			})
		},
		ShoppingCart(id) {
			ElMessageBox.prompt('请填写数量！', '加入购物车', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					inputValue: '1'

				})
				.then(({ value }) => {

				})
				.catch(() => {

				})
		},
		report(id) {
			ElMessageBox.prompt('请填写举报理由！', '举报', {
					confirmButtonText: '确认',
					cancelButtonText: '取消',

				})
				.then(({ value }) => {

				})
				.catch(() => {

				})
		},
		preview(row, img) {
			this.srcList = [];
			/*this.srcList_index = 0
			this.showPreview = true;*/
			var obj = this;
			img.forEach(function(item) {
				obj.srcList.push(item)
			})
			this.$refs['examineImg'].img_title = row;
			this.$refs['examineImg'].data = this.srcList;
			this.$refs['examineImg'].dialogTableVisible = true;
			this.$refs['examineImg'].imgBigUrl = this.srcList[0];
		},
		rowDblclick(row) {
			const newUrl = this.$router.resolve({ path: '/product', query: { id: row.id } }).href;
			window.open(newUrl, '_blank');
		},
		HeadIndexSearch(val) {
			this.filter = val.filter
			this.stock_type = val.stock_type
			this.img_info = val.img_info
			this.page = 1;
			this.search();
		},
		handleCurrentChange(val) {
			this.page = val;
			this.search();
		},
		async search() {
			if (this.loading) {
				return false;
			}
			this.loading = true
			var search = { page: this.page, ps: this.page_size, filter: this.filter , stock_type: this.stock_type,img_info : this.img_info}
			await this.$axios.post('/api/yunsys.Storage/getstorage', search).then(async (res) => {
					var res = res.data;
					this.loading = false
					if (res.code !== 0) {
						return ElMessage({
							message: res.msg,
							type: 'error',
							grouping: true // 开启合并功能
						})
					}
					var obj = this;
					this.total = 99999999999;
					res.data.forEach(item => {
						item.stock_type_txt_list = item.stock_type_txt.split("、");
						//console.log(item.stock_type_txt_list)
						if (obj.user_id) {
							item.real_money = obj.$bn.multiply(item.sur_num, item.real_price, 2);
							item.real_price = obj.$bn.multiply(item.real_price, 1, 2);
							item.tsw_price = obj.$bn.multiply(item.tsw_price, 1, 2);
							item.tsw_discount = obj.$bn.divide(item.tsw_price, item.price, 3)
						} else {
							item.real_money = '*'
							item.real_price = '*'
							item.discount_calculate = '*'
							item.sur_num = '*'
						}

					})
					this.tableData = res.data;

				})
				.catch(err => {
					console.log(err)
					this.loading = false
					return ElMessage({
						message: '系统错误',
						type: 'error',
						grouping: true // 开启合并功能

					})
				})
		}
	}
}
</script>
<style lang="less" scoped>
:deep(.el-page-header__header) {

	line-height: 32px;
	margin-left: 30px;
}

:deep(.acquiesce .el-button:hover) {
	color: #fff;
	background-color: #ff8a5c;
	border-color: #ff8a5c;
	border: 0;
}
:deep(.el-pager .number){
	display:none
}
:deep(.el-pager .more){
	display:none
}
:deep(.el-pager .is-active){
	//display:block
}
.stock_type_txt_button .el-button {
	margin-right: 5px;
	font-size: 0.70rem !important;
	padding: 0.2525rem 0.5875rem;
}

.stock_type_txt_button .A {
	color: #ff8a5c;
	background-color: rgb(255, 240, 228) !important;
}

.stock_type_txt_button .B {
	color: red;
	background-color: rgb(255, 243, 245) !important;
}

.stock_type_txt_button .C {
	color: rgb(75, 212, 205);
	background-color: rgb(223, 255, 251) !important;
}

:deep(.el-input-group__append) {
	background: #ff8a5c;
}

.caozuo {
	top: 11px;
	position: absolute;
}

.caozuo .el-icon {
	margin-right: 10px
}

:deep(.district .el-input-group__prepend) {
	background-color: #fff;
	color: #ff8a5c;
}

:deep(.district .el-input-group__append) {
	background-color: #fff;
	color: #ff8a5c;
}

:deep(.el-image) {
	border-radius: 3px;
	height: 38px;
	width: 38px;
	display: inline-block;
	display: flex;
}

:deep(.acquiesce .el-button) {

	border: 0;
}

:deep(.info .el-button:hover) {
	color: #fff;
	background-color: #ff8a5c;
	border-color: #ff8a5c;
}

:deep(.name .el-button:hover) {
	color: #ff8a5c;
}

:deep(.name .el-button:active) {
	color: #ff8a5c;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
	background-color: #ff8a5c;
}

:deep(.el-form-item__label) {
	font-size: 13px;
}

:deep(.el-form-item) {

	margin-bottom: 8px;
}

.logo_m {
	margin: 15px 0px 15px 0px;
	height: auto;
}
</style>